"use strict";

export class init {
    constructor() {
        this.init();
    }

    init() {
        $(document).on('click', '.all-block-as-link', function (e) {
            let target = $(e.target);

            if (target.is('a')) {
                return;
            } else if (target.is('button')) {
                return;
            } else if (target.is('img')) {
                return;
            } else if (target.is('li') || target.is('span.switch-cv-status') || target.is('span.slider')) {
                return;
            } else {
                window.open($(this).attr('data-link'), '_self');
            }
        });
    }
}
